(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-header-search-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const TYPING_SPEED   = 80;
    const DELETING_SPEED = 40;
    const PAUSE_TYPED    = 1600;
    const PAUSE_DELETED  = 320;

    const setupTypewriter = (input) => {
      if (input.__twInit) return;
      input.__twInit = true;

      const prefix = input.getAttribute('data-animated-prefix') || '';
      const raw    = input.getAttribute('data-animated-placeholders') || '';
      const words  = raw.split('|').map((s) => s.trim()).filter(Boolean);
      if (!words.length) return;

      let wordIndex  = 0;
      let charIndex  = 0;
      let deleting   = false;
      let timerId    = null;

      const paused = () => document.activeElement === input || input.value.length > 0;

      const tick = () => {
        if (paused()) {
          timerId = setTimeout(tick, 500);
          return;
        }

        const word = words[wordIndex];

        if (!deleting) {
          charIndex++;
          input.placeholder = prefix + word.slice(0, charIndex);

          if (charIndex === word.length) {
            deleting = true;
            timerId  = setTimeout(tick, PAUSE_TYPED);
          } else {
            timerId = setTimeout(tick, TYPING_SPEED);
          }
        } else {
          charIndex--;
          input.placeholder = prefix + word.slice(0, charIndex);

          if (charIndex === 0) {
            deleting   = false;
            wordIndex  = (wordIndex + 1) % words.length;
            timerId    = setTimeout(tick, PAUSE_DELETED);
          } else {
            timerId = setTimeout(tick, DELETING_SPEED);
          }
        }
      };

      input.placeholder = prefix;
      timerId = setTimeout(tick, 600);

      input.__twStop = () => { clearTimeout(timerId); };
    };

    const init = () => {
      document
        .querySelectorAll('[data-custom-header-search] input[data-animated-placeholders]')
        .forEach(setupTypewriter);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:reorder', init);
    document.addEventListener('shopify:section:select', init);
  })();
  } catch(e) { console.error(e); }
})();

})();
